<template>
  <div id="app" v-cloak>
    <!-- 添加初始加载状态 -->
    <div v-if="appInitializing" class="app-loading">
      <div class="loading-spinner"></div>
      </div>
      
    <!-- 只在应用初始化完成后才显示内容 -->
    <template v-else>
      <!-- 只在已登录状态显示导航栏 -->
      <NavBar 
        v-if="isLoggedIn"
        :is-logged-in="isLoggedIn" 
        @logout="handleLogout"
      />
      
      <div class="main-content">
        <router-view 
          @login-success="handleLoginSuccess"
          @auth-error="handleAuthError"
        />
      </div>
    </template>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    NavBar
  },
  data() {
    return {
      isLoggedIn: false,
      token: localStorage.getItem('token') || '',
      appInitializing: true
    }
  },
  methods: {
    // 处理登录成功
    handleLoginSuccess(token) {
      this.token = token;
      this.isLoggedIn = true;
    },
    
    // 处理登出
    handleLogout() {
      localStorage.removeItem('token');
      this.token = '';
      this.isLoggedIn = false;
      
      // 跳转到登录页
      this.$router.push('/login');
    },
    
    // 处理认证错误
    handleAuthError() {
      this.isLoggedIn = false;
      this.token = '';
      localStorage.removeItem('token');
      
      // 跳转到登录页面，并显示错误信息
      this.$router.push({
        name: 'Login',
        query: { error: '登录已过期，请重新登录' }
      });
    },
    
    // 初始化应用认证状态
    async initAuth() {
      const savedToken = localStorage.getItem('token');
      
      if (savedToken) {
        try {
          const response = await axios.get('/api/auth/verify', {
            headers: {
              'Authorization': `Bearer ${savedToken}`
            }
          });
          
          if (response.data.code === 200) {
            this.token = savedToken;
            this.isLoggedIn = true;
          } else {
            // 无效令牌，清除存储
            localStorage.removeItem('token');
            this.isLoggedIn = false;
            this.token = '';
          }
        } catch (error) {
          console.error('令牌验证失败:', error);
          // 验证失败，清除存储
          localStorage.removeItem('token');
          this.isLoggedIn = false;
          this.token = '';
        }
        } else {
        // 无令牌
        this.isLoggedIn = false;
        this.token = '';
      }
      
      // 初始化完成后关闭加载状态
      this.appInitializing = false;
    }
  },
  created() {
    // 在组件创建时初始化认证状态
    this.initAuth();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 20px;
}

/* 添加v-cloak指令样式，防止初始渲染闪烁 */
[v-cloak] {
  display: none;
}

/* 添加加载状态样式 */
.app-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  z-index: 9999;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(64, 158, 255, 0.2);
  border-radius: 50%;
  border-top-color: #409EFF;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>